import { render, staticRenderFns } from "./SilicOneBrochures.vue?vue&type=template&id=e4e58636"
import script from "./SilicOneBrochures.vue?vue&type=script&lang=js"
export * from "./SilicOneBrochures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports